import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "payments-widget__tiles" }
const _hoisted_2 = { class: "payments-widget__row" }
const _hoisted_3 = { class: "payments-widget__block" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-3" }, " Заказы за 24 часа ", -1)
const _hoisted_5 = { class: "payments-widget__block" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-3" }, " Поступления ", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Сегодня: ")
const _hoisted_8 = { class: "text-muted" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" С начала месяца: ")
const _hoisted_10 = { class: "text-muted" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Заказы ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Платежи ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Счета и акты ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Товары ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Журнал ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_stat_tile = _resolveComponent("stat-tile")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dashboard_widget = _resolveComponent("dashboard-widget")!

  return (_openBlock(), _createBlock(_component_dashboard_widget, {
    title: "Платежи и заказы",
    loading: _ctx.loading,
    loaded: _ctx.data !== null,
    error: _ctx.error,
    attention: _ctx.data ? _ctx.data.attention : 0,
    "updated-at": _ctx.updatedAt,
    onRefresh: _ctx.refresh
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_router_link, {
        class: "el-button el-button--small",
        to: { name: 'payments-orders' }
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "el-button el-button--small",
        to: { name: 'payments-list' }
      }, {
        default: _withCtx(() => [
          _hoisted_12
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "el-button el-button--small",
        to: { name: 'payments-documents' }
      }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "el-button el-button--small",
        to: { name: 'payments-products' }
      }, {
        default: _withCtx(() => [
          _hoisted_14
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "el-button el-button--small",
        to: { name: 'payments-audit' }
      }, {
        default: _withCtx(() => [
          _hoisted_15
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (_ctx.data)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_stat_tile, {
                label: "Ждут оплаты",
                value: _ctx.data.orders_unpaid.count,
                hint: _ctx.unpaidHint,
                tone: _ctx.data.orders_unpaid.count > 0 ? 'warning' : 'ok',
                to: { name: 'payments-orders', query: { unpaid: 'true' } }
              }, null, 8, ["value", "hint", "tone"]),
              _createVNode(_component_stat_tile, {
                label: "Просрочены",
                value: _ctx.data.invoices_awaiting.overdue,
                hint: "заказы со счётом, срок оплаты и отсрочка прошли",
                tone: _ctx.data.invoices_awaiting.overdue > 0 ? 'danger' : 'ok',
                to: { name: 'payments-orders', query: { overdue_invoice: 'true' } }
              }, null, 8, ["value", "tone"]),
              _createVNode(_component_stat_tile, {
                label: "Оплачены, услуги не выданы",
                value: _ctx.data.stuck_orders.count,
                hint: _ctx.data.stuck_orders.count ? `самый старый: ${_ctx.ago(_ctx.data.stuck_orders.oldest_at)}` : 'всё выдано',
                tone: _ctx.data.stuck_orders.count > 0 ? 'danger' : 'ok',
                to: { name: 'payments-orders', query: { stuck: 'true' } }
              }, null, 8, ["value", "hint", "tone"]),
              _createVNode(_component_stat_tile, {
                label: "Открытые инциденты",
                value: _ctx.data.open_incidents.count,
                hint: _ctx.data.open_incidents.count ? `старейший: ${_ctx.ago(_ctx.data.open_incidents.oldest_at)}` : 'платежи, требующие решения',
                tone: _ctx.data.open_incidents.count > 0 ? 'danger' : 'ok',
                to: { name: 'payments-incidents' }
              }, null, 8, ["value", "hint", "tone"])
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (status) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    key: status,
                    class: _normalizeClass(["payments-widget__chip", { 'payments-widget__chip--empty': !_ctx.data.orders_24h[status] }]),
                    to: { name: 'payments-orders', query: { status: status, created_from: _ctx.yesterday } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.statusLabels[status]) + ": ", 1),
                      _createElementVNode("b", null, _toDisplayString(_ctx.data.orders_24h[status]), 1)
                    ]),
                    _: 2
                  }, 1032, ["class", "to"]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", null, [
                  _hoisted_7,
                  _createElementVNode("b", null, _toDisplayString(_ctx.money(_ctx.data.revenue.today.amount)), 1),
                  _createElementVNode("span", _hoisted_8, " · платежей: " + _toDisplayString(_ctx.data.revenue.today.count), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_9,
                  _createElementVNode("b", null, _toDisplayString(_ctx.money(_ctx.data.revenue.month.amount)), 1),
                  _createElementVNode("span", _hoisted_10, " · платежей: " + _toDisplayString(_ctx.data.revenue.month.count), 1)
                ])
              ])
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading", "loaded", "error", "attention", "updated-at", "onRefresh"]))
}